<template>
  <div class="relative fixed-top">
    <Banner />
    <div class="flex">
      <b-card no-body class="w-4/12 shadow-xl bg-white">
        <Contacts />
      </b-card>

      <div class="w-8/12 px-1">
        <b-card no-body class="">
          <Messages />
        </b-card>
      </div>
      <!-- <b-card class="w-1/4">
       <Note /> 
    </b-card> -->
    </div>
  </div>
</template>

<script>
import Banner from "./Banner.vue";
import Contacts from "./Contacts/Contacts.vue";
import Messages from "./Messages/Messages.vue";
import Note from "./Note/Note.vue";
export default {
  components: {
    Banner,
    Contacts,
    Messages,
    Note,
  },
};
</script>
